import { getApiClient } from './apiService'
import config from '../config/env'

export const CONVERSATIONS_PER_PAGE = 15

// Get my conversations
const getConversations = async ({ page = 1 }) => {
  try {
    const response = await getApiClient().get(
      `/conversations?page=${page}&per_page=${CONVERSATIONS_PER_PAGE}`,
    )
    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getConversations error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

// Start or get private conversation
const privateConversation = async ({ userId }) => {
  try {
    const response = await getApiClient().post(
      `/conversations/private/${userId}`,
    )
    if ((response.status === 201 || response.status === 200) && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('privateConversation error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

// Start or get product conversation
const productConversation = async ({ productId }) => {
  try {
    const response = await getApiClient().post(
      `/conversations/product/${productId}`,
    )
    if ((response.status === 201 || response.status === 200) && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('productConversation error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const getMessages = async ({ conversationId, page }) => {
  try {
    const url = `/conversations/${conversationId}/messages?page=${page}`
    if (config.DEBUG) console.log('getMessages url: ', url)

    const response = await getApiClient().get(url)

    if (response.status === 200 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('getMessages error: ', error)
    let errorMessage = error.message

    const responseError = error.response.data?.message
    if (responseError) {
      errorMessage = responseError
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const sendMessage = async ({ conversationId, content }) => {
  const data = {
    content,
  }

  try {
    const response = await getApiClient().post(
      `/conversations/${conversationId}/messages`,
      data,
    )
    if (response.status === 201 && response.data) {
      return {
        isOk: true,
        data: response.data,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('privateConversation error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const createAdminRequestConversation = async ({ requestId, userIds }) => {
  const data = {
    request_id: requestId,
    user_ids: userIds,
  }

  try {
    const response = await getApiClient().post(
      `/conversations/admin/request`,
      data,
    )
    if (response.status === 201 && response.data.success) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG)
      console.log('createAdminRequestConversation error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

const markMessageAsRead = async ({ messageId }) => {
  try {
    const response = await getApiClient().post(`/messages/${messageId}/read`)
    if (response.status === 200 && response.data.success) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
        message: 'Desila se greška u zahtjevu',
      }
    }
  } catch (error) {
    if (config.DEBUG) console.log('markMessageAsRead error: ', error)
    let errorMessage = error.message

    const responseMessage = error?.response?.data?.message
    if (responseMessage) {
      errorMessage = responseMessage
    }

    return {
      isOk: false,
      message: errorMessage,
    }
  }
}

export const conversationsService = {
  getConversations,
  privateConversation,
  productConversation,
  sendMessage,
  getMessages,
  createAdminRequestConversation,
  markMessageAsRead,
}
